import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Hero from '../../components/Hero/Hero';
import ProductCard from '../../components/ProductCard/ProductCard';
import { FiArrowRight } from 'react-icons/fi';
import { FEATURED_PRODUCTS } from '../../data/products';
import './Home.css';

const Home = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => {
      setFeaturedProducts(FEATURED_PRODUCTS);
      setLoading(false);
    }, 400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="home">
      <Hero />

      <section className="new-in-section">
        <div className="container">
          <div className="section-tag">New In</div>
          <div className="section-header">
            <h2 className="section-title">T-Shirts</h2>
          </div>

          {loading ? (
            <div className="products-loading">
              <div className="loading-spinner" />
            </div>
          ) : (
            <div className="products-grid">
              {featuredProducts.map((product) => (
                <div key={product.id} className="product-wrapper">
                  <ProductCard product={product} />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="curated-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Curated for you</h2>
            <p className="section-description">
              A tight edit of premium cotton tees. Built for everyday rotation.
            </p>
          </div>

          <div className="curated-grid">
            {featuredProducts.slice(0, 4).map((product) => (
              <ProductCard key={`curated-${product.id}`} product={product} />
            ))}
          </div>
        </div>
      </section>

      <section className="lookbook-section">
        <div className="lookbook-background">
          <div className="lookbook-overlay" />
          <img
            src="/images/lookbook-bg.svg"
            alt=""
            className="lookbook-image"
          />
        </div>
        <div className="container">
          <div className="lookbook-content">
            <div className="lookbook-tag">SS26 Lookbook</div>
            <h2 className="lookbook-title">
              Between<br />Light & Shadow
            </h2>
            <p className="lookbook-description">
              A minimal palette and clean lines — the same language as our tees, extended to the season story.
            </p>
            <button
              type="button"
              className="lookbook-button"
              onClick={() => navigate('/lookbook')}
            >
              Explore Lookbook
              <FiArrowRight className="button-icon" />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
